import Vue from 'vue'
import Router from 'vue-router'

import index from '../view/index'

import login from '../view/Login'
import newLogin from '../view/newLogin'
import NotFound from '../view/404'
import workbench from '../view/企业工作台'

const fileUploadManage = r => require.ensure([], () => r(require('../view/事项管理/事项处理')), 'fileUploadManage');
const fileHandle = r => require.ensure([], () => r(require('../view/事项管理/formHandle')), 'fileHandle');

// const spreadInfo = r => require.ensure([], () => r(require('../view/企业资料/宣传信息')), 'spreadInfo');
// const billInfo = r => require.ensure([], () => r(require('../view/企业资料/开票信息')), 'billInfo');

const notification = r => require.ensure([], () => r(require('../view/园区通知/园区通知管理')), 'notification');

const selfEvaluation = r => require.ensure([], () => r(require('../view/考核管理/考核任务自评')), 'selfEvaluation');


const myApplication = r => require.ensure([], () => r(require('../view/工作流管理/我的申请')), 'myApplication');
const addApplication = r => require.ensure([], () => r(require('../view/工作流管理/新增申请')), 'addApplication');

const remindBill = r => require.ensure([], () => r(require('../view/提醒管理/账单提醒')), 'remindBill');
const remindOverTime = r => require.ensure([], () => r(require('../view/提醒管理/合同到期提醒')), 'remindOverTime');
const balanceRemind = r => require.ensure([], () => r(require('../view/提醒管理/水电余额提醒')), 'balanceRemind');

const peopleManage = r => require.ensure([], () => r(require('../view/移动端管理/人员管理')), 'peopleManage');
const visitorManage = r => require.ensure([], () => r(require('../view/移动端管理/访客管理')), 'visitorManage');
const faceManage = r => require.ensure([], () => r(require('../view/移动端管理/人脸信息管理')), 'faceManage');
const entryManage = r => require.ensure([], () => r(require('../view/移动端管理/人员出入明细')), 'entryManage');

const accountManage = r => require.ensure([], () => r(require('../view/系统管理/账号管理')), 'accountManage');
const systemManager = r => require.ensure([], () => r(require('../view/系统管理/系统管理员')), 'systemManager');
const primissionManage = r => require.ensure([], () => r(require('../view/系统管理/权限管理')), 'primissionManage');
const messageNotification = r => require.ensure([], () => r(require('../view/系统管理/消息通知')), 'messageNotification');

const doloadDataTemplate = r => require.ensure([], () => r(require('../view/资料模板/资料模板下载')), 'doloadDataTemplate');

const serviceDocking = r => require.ensure([], () => r(require('../view/园区服务/服务对接')), 'serviceDocking');

const problemManage = r => require.ensure([], () => r(require('../view/信息反馈/问题反馈')), 'problemManage');

const fileManage = r => require.ensure([], () => r(require('../view/文件管理/文件管理')), 'fileManage');

const attendanceRecord = r => require.ensure([], () => r(require('../view/考勤管理/人员考勤记录')), 'attendanceRecord');

const preventPlagueManagement = r => require.ensure([], () => r(require('../view/防疫登记/防疫管理')), 'preventPlagueManagement');
const reportPreventPlagueMessage = r => require.ensure([], () => r(require('../view/防疫登记/企业复工情况备案.vue')), 'reportPreventPlagueMessage');
const policyDemandSearch = r => require.ensure([], () => r(require('../view/防疫登记/企业政策需求调查')), 'policyDemandSearch');
const registrationReturningWorkers = r => require.ensure([], () => r(require('../view/防疫登记/企业复工人员登记.vue')), 'registrationReturningWorkers');
const applicationForWork = r => require.ensure([], () => r(require('../view/防疫登记/企业复工申请.vue')), 'applicationForWork');


const billApplicationManage = r => require.ensure([], () => r(require('../view/票据申请管理/票据申请管理')), 'billApplicationManage');

const parkingRentalApplication = r => require.ensure([], () => r(require('../view/车位租赁申请/车位租赁申请')), 'parkingRentalApplication');

const companySafeDocument = r => require.ensure([], () => r(require('../view/企业安全档案/企业安全档案.vue')), 'companySafeDocument');

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/login',
      hidden: true
    },
    {
      path: '/login',
      component: newLogin,
      name: '',
      hidden: true
    },
    {
      path: '/newLogin',
      component: newLogin,
      name: '',
      hidden: true
    },
    {
      path: '/404',
      component: NotFound,
      name: '',
      hidden: true
    },
    {
      path: '/index',
      name: '企业工作台',
      component: index,
      hidden: false,
      leaf: true,
      iconCls: 'icon-diannao',
      permission: 'work_bench',
      children: [
        {
          path: '/workbench', component: workbench, name: '企业工作台'
        },
      ]
    },
    {
      path: '/',
      name: '事项管理',
      component: index,
      hidden: false,
      iconCls: 'icon-biezhen',
      permission: 'matter_manager',
      children: [
        {
          path: '/fileUploadManage',
          component: fileUploadManage,
          name: '·事项处理',
          meta: { showAddHeader: false },
          permission: 'file_upload_manager'
        },
        {
          path: '/fileHandle',
          component: fileHandle,
          name: '·事项处理',
          hidden: true,
          meta: { showAddHeader: false },
          permission: 'file_upload_manager'
        },
      ]
    },
    {
      path: '/',
      name: '工作流管理',
      component: index,
      hidden: false,
      leaf: false,
      iconCls: 'icon-jurassic_history-record',
      permission: 'workflow_manager',
      children: [
        {
          path: '/myApplication', component: myApplication, name: '·我的工作流', permission: 'my_ask'
        },
        {
          path: '/addApplication', component: addApplication, name: '·工作流发起', permission: 'add_workflow'
        },
      ]
    },
    {
      path: '/',
      name: '考核管理',
      component: index,
      hidden: false,
      leaf: false,
      iconCls: 'icon-kaohe',
      permission: 'self_evaluation',
      children: [
        {
              path: '/selfEvaluation', component: selfEvaluation, name: '考核任务自评', permission: 'self_assessment'
        },

      ]
    },
    {
      path: '/',
      name: '园企服务',
      component: index,
      hidden: false,
      leaf: false,
      iconCls: 'icon-woshou',
      permission: 'portal_serve',
      children: [
        {
          path: '/serviceDocking', component: serviceDocking, name: '·服务对接', permission: 'serve_list'
        },
      ]
    },
    {
      path: '/',
      name: '信息反馈',
      component: index,
      hidden: false,
      leaf: false,
      iconCls: 'icon-yijianfankui',
      permission: 'information_reback',
      children: [
        {
          path: '/problemManage', component: problemManage, name: '·问题反馈', permission: 'feedback_list'
        },
      ]
    },
    {
      path: '/',
      name: '园区通知',
      component: index,
      hidden: false,
      iconCls: 'icon-tongzhi',
      permission: 'park_notify',
      children: [
        {
          path: '/notification',
          component: notification,
          name: '·园区通知管理',
          meta: { showAddHeader: false },
          permission: 'park_notice_manager'
        },
        {
          path: '/messageNotification', component: messageNotification, name: '·消息通知', permission: 'message_notify'
        },
      ]
    },
    {
      path: '/',
      name: '文件管理',
      component: index,
      hidden: false,
      iconCls: 'icon-wenjianguanli-02',
      permission: 'file_manage',
      children: [
        {
          path: '/fileManage',
          component: fileManage,
          name: '·文件管理',
          meta: { showAddHeader: false },
          permission: 'fileManage'
        },
      ]
    },
    {
      path: '/',
      name: '资料模板',
      component: index,
      hidden: false,
      iconCls: 'icon-huabanfuben',
      permission: 'resource_moban',
      children: [
        {
          path: '/doloadDataTemplate',
          component: doloadDataTemplate,
          name: '·资料模板下载',
          meta: { showAddHeader: false },
          permission: 'resource_download'
        },
      ]
    },
    {
      path: '/',
      name: '企业内部管理',
      component: index,
      hidden: false,
      iconCls: 'icon-neibuguanli',
      permission: 'moblie_manager',
      children: [
        {
          path: '/peopleManage',
          component: peopleManage,
          name: '·人员管理',
          meta: { showAddHeader: false },
          permission: 'user_manager'
        },
        {
          path: '/faceManage',
          component: faceManage,
          name: '·人脸信息管理',
          meta: { showAddHeader: false },
          permission: 'face_info_list'
        },
        {
          path: '/entryManage',
          component: entryManage,
          name: '·人员出入明细',
          meta: { showAddHeader: false },
          permission: 'person_pass_list'
        },
        {
          path: '/visitorManage',
          component: visitorManage,
          name: '·访客管理',
          meta: { showAddHeader: false },
          permission: 'visitor_manager'
        },
        {
          path: '/attendanceRecord',
          component: attendanceRecord,
          name: '·考勤管理',
          meta: { showAddHeader: false },
          permission: 'attendanceRecord'
        },
      ]
    },
    {
      path: '/',
      name: '提醒管理',
      component: index,
      hidden: false,
      iconCls: 'icon-tixing',
      permission: 'remind_manager',
      children: [
        {
          path: '/remindBill',
          component: remindBill,
          name: '·账单提醒',
          meta: { showAddHeader: false },
          permission: 'account_notify'
        },
        {
          path: '/remindOverTime',
          component: remindOverTime,
          name: '·合同到期提醒',
          meta: { showAddHeader: false },
          permission: 'bill_deadline_notify'
        },
        {
          path: '/balanceRemind',
          component: balanceRemind,
          name: '·水电余额提醒',
          meta: { showAddHeader: false },
          permission: 'balance_remind'
        },
      ]
    },
    {
      path: '/',
      name: '票据申请管理',
      component: index,
      hidden: false,
      iconCls: 'icon-piaoju',
      permission: 'bill_manage',
      children: [
        {
          path: '/billApplicationManage', component: billApplicationManage, name: '·票据申请管理', meta: { showAddHeader: false }, permission: 'bill_apply'
        },
      ]
    },
    {
      path: '/',
      name: '车位租赁申请',
      component: index,
      hidden: false,
      iconCls: 'icon-peitaosheshixiaotubiao_tingchewei',
      permission: 'parking_rental',
      children: [
        {
          path: '/parkingRentalApplication',
          component: parkingRentalApplication,
          name: '车位租赁申请',
          meta: { showAddHeader: false },
          permission: 'parking_rental_application'
        },
      ]
    },
    // {
    //   path: '/',
    //   name: '系统管理',
    //   component: index,
    //   hidden: false,
    //   iconCls: 'icon-shezhi',
    //   permission: 'system_manager',
    //   children: [
    //     {
    //       path: '/accountManage', component: accountManage, name: '·账号管理', permission: 'account_manager'
    //     },
    //     {
    //       path: '/systemManager', component: systemManager, name: '·系统管理员', permission: 'system_admin'
    //     },
    //     {
    //       path: '/primissionManage', component: primissionManage, name: '·权限管理', permission: 'permission_manager',
    //     },
    //       ]
    //     },
    // {
    //   path: '/',
    //   name: '防疫管理',
    //   component: index,
    //   hidden: false,
    //   // leaf: true, //只有一个节点
    //   iconCls: 'icon-attchment',
    //   permission: 'prevention_manage',
    //   children: [
    //     {
    //       path: '/preventPlagueManagement', component: preventPlagueManagement, name: '·企业防疫登记', permission: 'file_upload_manager'
    //     },
    //     {
    //       path: '/reportPreventPlagueMessage', component: reportPreventPlagueMessage, name: '·企业复工信息备案', permission: 'file_upload_manager'
    //     },
    //     {
    //       path: '/policyDemandSearch', component: policyDemandSearch, name: '·企业政策需求调查', permission: 'file_upload_manager'
    //     },
    //     {
    //       path: '/registrationReturningWorkers', component: registrationReturningWorkers, name: '·企业复工人员登记', permission: 'file_upload_manager'
    //     },
    //     // {
    //     //   path: '/applicationForWork', component: applicationForWork, name: '·企业复工申请', permission: 'file_upload_manager'
    //     // },
    //   ]
    // },
    // {
    //   path: '/',
    //   name: '租赁信息管理',
    //   component: index,
    //   hidden: false,
    //   // leaf: true, //只有一个节点
    //   iconCls: 'icon-attchment',
    //   permission: 'lease_info',
    //   children: [
    //     {
    //       path: '/siteManage', component: siteManage, name: '·场地管理', permission: 'file_upload_manager'
    //     },
    //     {
    //       path: '/contractManage', component: contractManage, name: '·合同管理', permission: 'file_upload_manager'
    //     },
    //     {
    //       path: '/billManage', component: billManage, name: '·账单管理', permission: 'file_upload_manager'
    //     },
    //   ]
    // },
    {
      path: '/',
      name: '企业安全档案',
      component: index,
      hidden: false,
      // leaf: true, //只有一个节点
      iconCls: 'icon-zulin',
      permission: 'company_safe',
      children: [
        {
          path: '/companySafeDocument', component: companySafeDocument, name: '·企业安全档案', permission: 'safe_ducoment'
        }
      ]
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js